
export type TypeParam2Parameter = typeof TypeParam2Parameter[keyof typeof TypeParam2Parameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TypeParam2Parameter = {
  FOR_YOU: 'FOR_YOU',
  USER: 'USER',
  FOLLOW: 'FOLLOW',
  DETAIL: 'DETAIL',
} as const;
